var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "18px",
    viewBox: "0 0 18 18",
    width: "18px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    id: "Core",
    transform: "translate(-213.000000, -171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "drive-ms-excel",
    transform: "translate(213.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 L16,0 Z M13.2,14 L11.2,14 L9,10.2 L6.8,14 L4.8,14 L8,9 L4.8,4 L6.8,4 L9,7.8 L11.2,4 L13.2,4 L10,9 L13.2,14 L13.2,14 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.822ccf9779ded1f6ef9ee7b98ce677e4.svg";
export { ForwardRef as ReactComponent };